'use strict';

var _ = require('lodash');
var ContributingFBGsGridAggregationFactory = function ContributingFBGsGridAggregationFactory(DataAggregationFactory) {
  function ContributingFBGsGridAggregation() {
    DataAggregationFactory.call(this, 'fares-mode', 'contributing-fbgs');
  }
  ContributingFBGsGridAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ContributingFBGsGridAggregation.constructor = ContributingFBGsGridAggregation;
  ContributingFBGsGridAggregation.prototype.aggregate = function (data) {
    var result = DataAggregationFactory.prototype.aggregate(data);
    return aggregateGroups(result);
  };
  return ContributingFBGsGridAggregation;
};
function aggregateGroups(data) {
  return _.chain(data).map(function (fbc) {
    fbc.groupKey = fbc.fareBasisGroup + ':' + fbc.bookingClass;
    return fbc;
  }).groupBy('groupKey').map(function (group, key) {
    var splittedKey = key.split(':');
    return {
      fareBasisGroup: splittedKey[0],
      className: splittedKey[1],
      totalTraffic: _.sumBy(group, 'traffic'),
      useForAveraging: _.get(group, '0.useForAveraging', true)
    };
  }).value();
}
ContributingFBGsGridAggregationFactory.$inject = ['ContributingFBCsGridAggregationFactory'];
module.exports = ContributingFBGsGridAggregationFactory;